module.exports = __webpack_public_path__ + "static/img/1.4794eaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/zh/1.png
// module id = ZFji
// module chunks = 0